const scopedRecordSchema = function(state, props) {
  let hideScopeSelection = state.view !== 'admin' && !props.readonly

  return {
    "ui:order": ["scopeId", "*"],
    "scopeId": {
      "ui:widget": hideScopeSelection ? "hidden" : null,
      "ui:field": "SimplePolymorphicSelectorField",
      "ui:label": I18n.t('api.forms.scoped_record.scope_id'),
      "ui:options": {
        "width": 4,
        "types": [
          {
            "entityName": "team",
            "displayAttribute": (team) => `${team.name}`
          },
          {
            "entityName": "employment",
            "displayAttribute": (employment) => `${employment.name}`
          }
        ]
      }
    },
    "scopeType": {
      "ui:widget": "hidden",
    },
  }
}

export default scopedRecordSchema;
